import { useEffect } from "react";

const useCurrencyTextReplace = () => { // temp solution, create a new font file to handle the currency
  useEffect(() => {
    let timeoutId;

    const replaceSAR = (node) => {
      if (node.nodeType === 3) {
        node.textContent = node.textContent.replace(/\bSAR\b/g, "ʢ");
      } else {
        node.childNodes.forEach(replaceSAR);
      }
    };

    const processChanges = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => replaceSAR(document.body), 0);
    };
    processChanges();
    const observer = new MutationObserver(() => processChanges());

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, []);
};

export default useCurrencyTextReplace;
